module.exports = __webpack_public_path__ + "static/media/1.2.2 Barbara Querschliff.c76d3418.jpg";